/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appointmentGetallprovidersandresources } from '../fn/appointment/appointment-getallprovidersandresources';
import { AppointmentGetallprovidersandresources$Params } from '../fn/appointment/appointment-getallprovidersandresources';
import { appointmentPrint } from '../fn/appointment/appointment-print';
import { AppointmentPrint$Params } from '../fn/appointment/appointment-print';
import { appointmentPrintSearch } from '../fn/appointment/appointment-print-search';
import { AppointmentPrintSearch$Params } from '../fn/appointment/appointment-print-search';
import { appointmentSearch } from '../fn/appointment/appointment-search';
import { AppointmentSearch$Params } from '../fn/appointment/appointment-search';
import { AppontmentDto } from '../models/appontment-dto';
import { DataPageOfAppointment } from '../models/data-page-of-appointment';

@Injectable({ providedIn: 'root' })
export class AppointmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appointmentGetallprovidersandresources()` */
  static readonly AppointmentGetallprovidersandresourcesPath = '/providers/getallprovidersandresources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appointmentGetallprovidersandresources()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentGetallprovidersandresources$Response(params?: AppointmentGetallprovidersandresources$Params, context?: HttpContext): Observable<StrictHttpResponse<AppontmentDto>> {
    return appointmentGetallprovidersandresources(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appointmentGetallprovidersandresources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentGetallprovidersandresources(params?: AppointmentGetallprovidersandresources$Params, context?: HttpContext): Observable<AppontmentDto> {
    return this.appointmentGetallprovidersandresources$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppontmentDto>): AppontmentDto => r.body)
    );
  }

  /** Path part for operation `appointmentSearch()` */
  static readonly AppointmentSearchPath = '/appointment/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appointmentSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentSearch$Response(params?: AppointmentSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfAppointment>> {
    return appointmentSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appointmentSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentSearch(params?: AppointmentSearch$Params, context?: HttpContext): Observable<DataPageOfAppointment> {
    return this.appointmentSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfAppointment>): DataPageOfAppointment => r.body)
    );
  }

  /** Path part for operation `appointmentPrintSearch()` */
  static readonly AppointmentPrintSearchPath = '/appointment/printlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appointmentPrintSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentPrintSearch$Response(params?: AppointmentPrintSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfAppointment>> {
    return appointmentPrintSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appointmentPrintSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentPrintSearch(params?: AppointmentPrintSearch$Params, context?: HttpContext): Observable<DataPageOfAppointment> {
    return this.appointmentPrintSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfAppointment>): DataPageOfAppointment => r.body)
    );
  }

  /** Path part for operation `appointmentPrint()` */
  static readonly AppointmentPrintPath = '/appointment/print';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appointmentPrint()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentPrint$Response(params?: AppointmentPrint$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return appointmentPrint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appointmentPrint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appointmentPrint(params?: AppointmentPrint$Params, context?: HttpContext): Observable<Blob> {
    return this.appointmentPrint$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
